/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, ElementRef, EventEmitter, ViewChild } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { faUpload, faImage } from "@fortawesome/free-solid-svg-icons";
import { NotificationService, StatementService } from "../../../../services";

@Component({
  selector: "app-updload-logo-modal",
  templateUrl: "./upload-logo-modal.component.html"
})
export class UploadLogoModalComponent {
  uploadedFileObject: any = null;
  logoImage!: SafeUrl;
  uploadedFileDimensions = {
    width: 0,
    height: 0
  };
  actionInProgress = false;
  faUpload = faUpload;
  faImage = faImage;
  merchantId!: number;
  public event: EventEmitter<SafeUrl> = new EventEmitter();

  constructor(
    private bsModalRef: BsModalRef,
    private sanitizer: DomSanitizer,
    private statementService: StatementService,
    private notificationService: NotificationService
  ) {}

  isImageUploaded(): boolean {
    return null !== this.uploadedFileObject;
  }

  handleUploadedImage(event: any) {
    this.uploadedFileObject = event.target.files[0];
    const objectUrl = URL.createObjectURL(this.uploadedFileObject);
    this.logoImage = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
  }

  @ViewChild("logo", { static: false }) logo!: ElementRef;
  onLoad() {
    this.uploadedFileDimensions.width = (this.logo.nativeElement as HTMLImageElement).naturalWidth;
    this.uploadedFileDimensions.height = (this.logo.nativeElement as HTMLImageElement).naturalHeight;
  }

  notSupportedMimeType(): boolean {
    return (
      this.isImageUploaded() &&
      this.uploadedFileObject.type !== "image/jpeg" &&
      this.uploadedFileObject.type !== "image/pjpeg" &&
      this.uploadedFileObject.type !== "image/png"
    );
  }

  imageTooHigh(): boolean {
    return this.uploadedFileDimensions.height > 150;
  }
  imageTooWide(): boolean {
    return this.uploadedFileDimensions.width > 200;
  }

  isImageValid(): boolean {
    return !this.imageTooHigh() && !this.imageTooWide() && !this.notSupportedMimeType();
  }

  uploadLogo(): void {
    if (this.isImageValid() && this.isImageUploaded()) {
      this.actionInProgress = true;
      this.statementService.uploadLogo(this.merchantId, this.uploadedFileObject).subscribe(
        () => {
          this.event.emit(this.logoImage);
          this.actionInProgress = false;
          this.close();
        },
        (error) => {
          this.notificationService.error(error.error);
          this.actionInProgress = false;
        }
      );
    }
  }

  close() {
    this.bsModalRef.hide();
  }
}
